module.exports = __webpack_public_path__ + "img/5.a995b442.svg";